const constraints = {
    userName: {
      presence: {
        allowEmpty: false
      },
  
      type: "string"
    },
  
    userSurname: {
      presence: {
        allowEmpty: false
      },
  
      type: "string"
    },

    email: {
      email: {
        pattern: "^[A-Z0-9._%+-]+@[A-Z0-9.-]+\\.[A-Z]{2,6}$",
        flags: "i",
        message: "^Некорректный адрес"
      },
  
      presence: {
        allowEmpty: false
      },
  
      type: "string"
    },
    phone: {
      format: {
        pattern: "^\\+?[1-9]\\d{1,14}$",
        message: "^Некорректный номер"
      },
    },
    password: {
      length: {
        minimum: 6,
        message: "^Cлишком короткий пароль, минимум 6 символов"
      },
  
      presence: {
        allowEmpty: false
      },
  
      type: "string"
    },
  

    playlistName: {
      presence: {
        allowEmpty: false,
        message: "^Укажите название планеты"
      }
    },
    auraColor: {
      presence: {
        allowEmpty: false,
        message: "^Укажите цвет ауры"
      }
    },
    playlistDescription: {
      presence: {
        allowEmpty: false,
        message: "^Укажите описание плейлиста"
      }
    }
  };
  
  export default constraints;